<template>
 <b-container fluid>
    <b-row class="mb-5" >
      <b-col lg="3">
        <!-- <h5>Ajouts</h5> -->
        <div class="border-bottom mb-3">
          <b-button
            v-b-modal.modal-typologies
            variant="primary"
            block
            class="mb-3"
          >
            Typologies
          </b-button>
          <b-button
            v-b-modal.modal-besoinECS
            variant="primary"
            block
            class="mb-3"
          >
            Besoin ECS
          </b-button>
          <b-button
            v-b-modal.modal-calculVaseExpansion
            variant="primary"
            block
            class="mb-3"
          >
            Calcul vase expansion
          </b-button>
          <!-- <b-button
            v-b-modal.modal-raccordBallons
            variant="primary"
            block
            class="mb-3"
          >
            Raccords entre ballon
          </b-button> -->
          <!-- <b-button
            v-b-modal.modal-besoinECS
            variant="primary"
            block
            class="mb-3"
          >
            Volume/zone géographique
          </b-button>
          <b-button
            v-b-modal.modal-besoinECS
            variant="primary"
            block
            class="mb-3"
          >
            Volume/zone climatique
          </b-button> -->
        </div>
      </b-col>
    </b-row>
    <ModalTypology />
    <ModalBesoinECS />
    <!-- <modal-raccord-ballons /> -->
    <modal-calcul-vase-expansion />
 </b-container>

</template>

<script>
    import ModalTypology from "./ModalTypology";
import ModalBesoinECS from "./ModalBesoinECS";
import ModalCalculVaseExpansion from './ModalCalculVaseExpansion.vue';
// import ModalRaccordBallons from './ModalRaccordBallons.vue';
export default {


  name: "CharacteristicsManagement",
  data() {
    return {
    
    };
  },
  components: {
          ModalTypology,
    ModalBesoinECS,
    ModalCalculVaseExpansion,
    // ModalRaccordBallons
  },
  mounted() {
   
  },
  methods: {
    
  },
  watch: {},
  computed: {
 
  },
};
</script>
<style>

</style>
